/**
 * 上次使用的 context_id（只有 id，不含任何顯示資料）。
 *
 * 身分本體存在 sessionStorage（useUser 的 persist），而 LINE rich menu 每次點擊都會開新的
 * webview／新的 document，sessionStorage 跟著全新 —— 於是每次開機都得等
 * `GET /customer/contexts` 回來拿到 context_id，才能打 `GET /customer/home`，兩支請求被迫串聯。
 *
 * 這裡把「上次用哪個 context」記在 localStorage（跨 document 存活），開機時就能先用它把
 * /home 與 /contexts 平行發出去。刻意只存 id：畫面仍然等 /home 真的回來才畫，
 * 不會出現上一次的數字。
 */

const KEY = "lpg.lastContextId.v1";

export function readLastContextId(): string | null {
  try {
    const v = localStorage.getItem(KEY);
    return v && v !== "" ? v : null;
  } catch {
    return null; // private mode / quota
  }
}

export function writeLastContextId(contextId: string | number | null | undefined): void {
  try {
    if (contextId == null || contextId === "") {
      localStorage.removeItem(KEY);
      return;
    }
    localStorage.setItem(KEY, String(contextId));
  } catch {
    /* silent */
  }
}
